/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useRef } from "react";
import { withTranslation } from "react-i18next";
import PropTypes, { string } from "prop-types";
import axios from "axios";
import {
  Dialog,
  Button,
  RadioButton,
  TextInput,
  Image,
  Anchor,
} from "hesus-ui-kit";
import ClipLoader from "react-spinners/ClipLoader";
import { handleApiError } from "@utils/errorHandler";
import { downloadFileFromUrl } from "@utils/fileDownload";
import closeIcon from "@icons/ic-close-white.svg";
import downloadIcon from "@icons/ic-download.svg";
import DocumentUpload from "@components/DocumentUpload/DocumentUpload";
import DocumentUploadAnotherType from "@components/DocumentUpload/DocumentUploadAnotherType";
import DocumentSelectWithType from "@components/DocumentUpload/DocumentSelectWithType";
import enableIcon from "@icons/ic-enable.svg";
import disableIcon from "@icons/ic-disable.svg";
import CKEditorText from "@components/CKEditorText/CKEditorText";
import {
  quoteLostHesusReasons,
  quoteMoreActionPopUpText,
} from "@utils/constants";
import UserInfo from "@utils/UserInfo";
import errorIcon from "@icons/ic-error.svg";
import {
  labelStyles,
  inputStyles,
  labelStylesError,
  inputStylesError,
  RequiredMessage,
} from "@utils/extra-style";
import { convertEditorJSToHTML } from "@utils/editorJsToHtml";
import {
  HeaderWrapper,
  Title,
  ButtonWrapper,
  FormBody,
  OptionsWrapper,
  FlexRow,
  SectionContainer,
  GridRow,
  MainTitleText,
  QuestionText,
  ReasonText,
  ErrorDiv,
  CancelText,
  ToggleText,
  ContactContainer,
  ContactButton,
  LabelText,
  QuoteText,
} from "./QuoteActionPopUp.styled";
import "../../QuoteList.scss";

const QuoteActionPopUp = (props) => {
  const {
    t,
    statusId,
    onClose,
    countryId,
    oldStatusId,
    onRefreshData,
    quoteId,
    setIsRefeshSiteData,
    siteId,
    pageType,
    jobsiteNeedKickoff,
  } = props;
  const [isQuoteAction, setIsQuoteAction] = useState(false);
  const [actionType, setActionType] = useState(false);
  const [existingDocuments, setExistingDocuments] = useState([]);
  const [documentList, setDocumentList] = useState([]);
  const [quoteDocumentList, setQuoteDocumentList] = useState([]);
  const [descriptionData, setDescriptionData] = useState("");
  const [adminData, setAdminData] = useState("");
  const [quoteTypes, setQuoteTypes] = useState(
    quoteMoreActionPopUpText[oldStatusId]
  );

  const [createQuoteActionAPIError, setCreateQuoteActionAPIError] =
    useState("");
  const [quoteReasons, setQuoteReasons] = useState([]);

  useEffect(() => {
    if (parseInt(statusId, 10) === 2) {
      axios
        .get(
          `/quotes/${quoteId}/generateClientEmail?adminId=${
            UserInfo.getUser().id
          }`
        )
        .then((response) => {
          setAdminData(response?.data?.emailData[0]);
        })
        .catch((error) => handleApiError(error));

      axios
        .get(
          `/documents?siteId=${siteId}&type="${JSON.stringify([
            1, 2, 3, 4, 15,
          ])}"`
        )
        .then((response) => {
          setDocumentList(response?.data?.documents);
        })
        .catch((error) => handleApiError(error));
      axios
        .get(`/documents?quoteId=${quoteId}&type="${JSON.stringify([15])}"`)
        .then((response) => {
          setQuoteDocumentList(response?.data?.documents[0]);
        })
        .catch((error) => handleApiError(error));
    }
  }, []);

  const generateQuotePdf = () => {
    axios
      .get(`/quotes/${quoteId}/generatePDF`)
      .then((response) => {
        downloadFileFromUrl(response?.data?.downloadLink);
      })
      .catch((error) => handleApiError(error));
  };

  const [formData, setFormData] = useState({
    statusId: {
      required: true,
      value: statusId,
      error: "",
    },
    reasonId: {
      required: true,
      value: "",
      error: "",
    },
    quotePoNumber: {
      required: true,
      value: "",
      error: "",
    },
    sendToClient: {
      value: false,
      error: "",
      required: true,
    },
    emailRecipients: {
      value: false,
      error: "",
      required: true,
    },
    emailSubject: {
      value: false,
      error: "",
      required: true,
    },
    emailBody: {
      value: false,
      error: "",
      required: true,
    },
    selectedDocuments: {
      value: "",
      error: "",
      required: true,
    },
    documentsTypeTwo: [],
    documents: [],
    documentsTypeTwoError: "",
  });

  useEffect(() => {
    if (parseInt(statusId, 10) === 2) {
      const convertedBody = convertEditorJSToHTML(adminData.body);
      setFormData({
        ...formData,
        emailSubject: {
          value: adminData.subject,
          error: "",
          required: true,
        },
        emailBody: {
          value: convertedBody,
          error: "",
          required: true,
        },
        emailRecipients: {
          value: adminData.recipients,
          error: "",
          required: true,
        },
      });
    }
  }, [adminData]);

  useEffect(() => {
    if ([6, 7].includes(parseInt(statusId, 10))) {
      setQuoteReasons(quoteLostHesusReasons[statusId][countryId]);
      const quoteData = quoteTypes.find(
        (quoteType) => quoteType.id === statusId
      );
      setActionType(quoteData);
    }
  }, [statusId]);

  const onReasonSelect = (e) => {
    setFormData({
      ...formData,
      reasonId: {
        value: e.target.value,
        error: "",
        required: true,
      },
    });
  };
  const onquotePoNumberChange = (e) => {
    setFormData({
      ...formData,
      quotePoNumber: {
        value: e.target.value,
        error: "",
        required: true,
      },
    });
  };

  const onEmailSubjectChange = (e) => {
    setFormData({
      ...formData,
      emailSubject: {
        value: e.target.value,
        error: "",
        required: true,
      },
    });
  };

  useEffect(() => {
    setFormData({
      ...formData,
      emailBody: {
        value: descriptionData,
        error: "",
        required: true,
      },
    });
  }, [descriptionData]);

  const validateForm = (data) => {
    let isFormValid = true;
    if ([6, 7].includes(parseInt(statusId, 10)) && !data.reasonId.value) {
      isFormValid = false;
      data.reasonId.error = t("QUOTE_LOST_REASON_ERROR");
    }
    if (
      [3].includes(parseInt(statusId, 10)) &&
      formData.documentsTypeTwo.length === 0 &&
      parseInt(oldStatusId, 10) !== 1
    ) {
      isFormValid = false;
      data.documentsTypeTwoError = t("QUOTE_VALIDATION_CLIENT_PO_ERROR");
    }
    if (parseInt(statusId, 10) === 2) {
      if (!data.emailSubject.value) {
        isFormValid = false;
        data.emailSubject.error = t("GENERAL_MANDATORY_ERROR");
      }
      if (!data.emailBody.value && data.emailBody.value === "") {
        isFormValid = false;
        data.emailBody.error = t("GENERAL_MANDATORY_ERROR");
      }
    }
    if (!isFormValid) {
      setFormData({ ...data });
    }
    return isFormValid;
  };

  const getFormData = () => {
    const dataModified = new FormData();
    dataModified.append("newStatusId", statusId);
    dataModified.append("previousStatusId", oldStatusId);
    if ([6, 7].includes(parseInt(statusId, 10))) {
      dataModified.append("reasonLost", formData.reasonId.value);
    }
    if (parseInt(statusId, 10) === 3) {
      dataModified.append("purchaseOrderNumber", formData.quotePoNumber.value);
      if (formData.documentsTypeTwo.length > 0) {
        for (let i = 0; i < formData.documentsTypeTwo.length; i++) {
          dataModified.append(`documents[${i}][type][id]`, 22);
          dataModified.append(
            `documents[${i}][filename]`,
            formData.documentsTypeTwo[i].name
          );
          dataModified.append(
            `documents[${i}][file]`,
            formData.documentsTypeTwo[i]
          );
        }
      }

      if (formData.documents.length > 0) {
        for (let i = 0; i < formData.documents.length; i++) {
          dataModified.append(`documents[${i}][type][id]`, 23);
          dataModified.append(
            `documents[${i}][filename]`,
            formData.documents[i].name
          );
          dataModified.append(`documents[${i}][file]`, formData.documents[i]);
        }
      }
    }
    if (parseInt(statusId, 10) === 2) {
      dataModified.append("sendToClient", formData.sendToClient.value ? 1 : 0);
      dataModified.append(
        `email[emailRecipients]`,
        JSON.stringify(formData.emailRecipients.value)
      );
      dataModified.append("email[emailSubject]", formData.emailSubject.value);
      dataModified.append("email[emailBody]", formData.emailBody.value);
      dataModified.append("email[attachedDocuments]", [
        formData.selectedDocuments.value,
      ]);
    }
    return dataModified;
  };

  const onSubmit = () => {
    const isFormValid = validateForm(formData);
    if (isFormValid) {
      const data = getFormData(formData);
      setIsQuoteAction(!isQuoteAction);
      setCreateQuoteActionAPIError("");
      // Create solution
      axios
        .post(`/quotes/${quoteId}/transitionStatus`, data, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(() => {
          onClose();
          setIsQuoteAction(!isQuoteAction);
          onRefreshData(true);
          if (pageType === "view") setIsRefeshSiteData(true);
        })
        .catch((error) => {
          setIsQuoteAction(!isQuoteAction);
          setCreateQuoteActionAPIError(error.response?.data?.message ?? "");
        });
    }
  };
  const checkRequiredStatus = (quoteStatusId, siteNeedKickoff) => {
    let isRequired = false;
    if (parseInt(quoteStatusId, 10) !== 1) {
      isRequired = true;
    }
    if (parseInt(quoteStatusId, 10) === 1 && !siteNeedKickoff) {
      isRequired = false;
    }
    return isRequired;
  };

  return (
    <Dialog width={statusId === "5" ? "35rem;" : "55rem;"}>
      <div>
        <HeaderWrapper>
          <Title>{t("QUOTE_STATUS_UPDATE_HEADER")}</Title>
          <Button
            onClick={onClose}
            styles={{
              backgroundColor: "transparent",
              border: "none",
              height: "auto",
              padding: 0,
              "&:hover": {
                backgroundColor: "transparent",
              },
            }}
          >
            <Image
              src={closeIcon}
              alt="close meeting report popup"
              className="quote-listing__quote-action-icon"
              styles={{ width: "20px" }}
            />
          </Button>
        </HeaderWrapper>

        <FormBody>
          <OptionsWrapper>
            <FlexRow>
              <SectionContainer>
                {[6, 7].includes(parseInt(statusId, 10)) && (
                  <div>
                    <GridRow column="1fr">
                      <MainTitleText>
                        {t("QUOTE_LOST_REASON_INFORMATION_MESSAGE")} :{" "}
                        <ReasonText>{t(actionType?.label)}</ReasonText>
                      </MainTitleText>
                    </GridRow>
                    <GridRow>
                      <QuestionText>
                        {t("QUOTE_LOST_REASON_SELECTION_MESSAGE")} ?{" "}
                      </QuestionText>
                    </GridRow>
                    {formData.reasonId.error && (
                      <GridRow column="1fr">
                        <ErrorDiv>
                          <RequiredMessage>
                            <Image
                              src={errorIcon}
                              alt="warning"
                              className="quote-listing__quote-action-icon"
                              styles={{ width: "20px" }}
                            />
                            {t(formData.reasonId.error)}
                          </RequiredMessage>
                        </ErrorDiv>
                      </GridRow>
                    )}
                    <GridRow>
                      <div className="quote-more-actions-reason">
                        <RadioButton
                          value={formData.reasonId.value}
                          onChange={onReasonSelect}
                          name="quote-reasons"
                          options={quoteReasons}
                        />
                      </div>
                    </GridRow>
                  </div>
                )}
                {parseInt(statusId, 10) === 5 && (
                  <div>
                    <GridRow column="1fr">
                      <MainTitleText>
                        {t("QUOTE_CANCEL_CONFIRMATION_BOX_TITLE")}
                        <ReasonText>{t(actionType?.label)}</ReasonText>
                      </MainTitleText>
                    </GridRow>
                    <GridRow>
                      <CancelText>
                        {t("QUOTE_CANCEL_CONFIRMATION_BOX_CONTENT")}
                      </CancelText>
                    </GridRow>
                  </div>
                )}
                {parseInt(statusId, 10) === 3 && (
                  <div>
                    <GridRow column="1fr">
                      <MainTitleText>
                        {t("QUOTE_VALIDATION_INFORMATION_MESSAGE")}
                        <ReasonText>{t(actionType?.label)}</ReasonText>
                      </MainTitleText>
                    </GridRow>
                    <GridRow column="1fr 1fr">
                      <TextInput
                        type="text"
                        label={t("QUOTE_VALIDATION_PO_NUMBER")}
                        onChange={onquotePoNumberChange}
                        name="quote-po-number"
                        id="quote-po-number"
                        value={String(formData.quotePoNumber?.value) || ""}
                        isFloat
                        errorStyles={{ "font-style": "italic" }}
                        labelStyles={
                          formData.quotePoNumber.error !== ""
                            ? labelStylesError
                            : labelStyles
                        }
                        inputStyles={
                          formData.quotePoNumber.error !== ""
                            ? inputStylesError
                            : inputStyles
                        }
                        error={formData.quotePoNumber.error}
                        containerStyles={{ marginTop: "21px" }}
                        placeholder={t("QUOTE_VALIDATION_PO_NUMBER")}
                      />
                    </GridRow>
                    {/* {parseInt(oldStatusId, 10) === 1 && !jobsiteNeedKickoff && (
                      <DocumentUpload
                        isEditMode={false}
                        title="QUOTE_VALIDATION_CLIENT_PO"
                        setFormData={setFormData}
                        formData={formData}
                        existingDocuments={existingDocuments}
                        setExistingDocuments={setExistingDocuments}
                        addMore={formData.documentsTypeTwo.length > 0 ? 0 : 1}
                      />
                    )} */}
                    {(parseInt(oldStatusId, 10) !== 1 ||
                      (parseInt(oldStatusId, 10) === 1 &&
                        !jobsiteNeedKickoff)) && (
                      <DocumentUploadAnotherType
                        isEditMode={false}
                        title="QUOTE_VALIDATION_CLIENT_PO"
                        setFormData={setFormData}
                        formData={formData}
                        existingDocuments={existingDocuments}
                        setExistingDocuments={setExistingDocuments}
                        addMore={formData.documentsTypeTwo.length > 0 ? 0 : 1}
                        isRequired={checkRequiredStatus(
                          oldStatusId,
                          jobsiteNeedKickoff
                        )}
                      />
                    )}
                    {formData.documentsTypeTwoError && (
                      <GridRow column="1fr">
                        <ErrorDiv>
                          <RequiredMessage>
                            <Image
                              src={errorIcon}
                              alt="warning"
                              className="quote-listing__quote-action-icon"
                              styles={{ width: "20px" }}
                            />
                            {t(formData.documentsTypeTwoError)}
                          </RequiredMessage>
                        </ErrorDiv>
                      </GridRow>
                    )}
                    <DocumentUpload
                      isEditMode={false}
                      setFormData={setFormData}
                      formData={formData}
                      existingDocuments={existingDocuments}
                      setExistingDocuments={setExistingDocuments}
                      title="QUOTE_VALIDATION_SITE_PROTOCOL"
                      addMore={formData.documents.length > 0 ? 0 : 1}
                    />
                  </div>
                )}
                {parseInt(statusId, 10) === 2 && (
                  <div>
                    <GridRow column="1fr" marginBottom="25px">
                      <div>
                        <Image
                          className="quote-listing__quote-action-icon"
                          styles={{ width: "25px" }}
                          src={
                            formData.sendToClient.value
                              ? enableIcon
                              : disableIcon
                          }
                          alt={t("QUOTE_TOGGLE_SEND_TO_CLIENT")}
                          title={t("QUOTE_TOGGLE_SEND_TO_CLIENT")}
                          marginLeft="7px"
                          onClick={() => {
                            setFormData({
                              ...formData,
                              sendToClient: {
                                value: !formData.sendToClient.value,
                                error: "",
                                required: true,
                              },
                            });
                          }}
                        />
                        <ToggleText>
                          {t("QUOTE_TOGGLE_SEND_TO_CLIENT")}
                        </ToggleText>
                      </div>
                    </GridRow>
                    {formData.sendToClient.value && (
                      <>
                        <GridRow>
                          <QuoteText>
                            {t("QUOTE_SEND__TO_CLIENT_INFORMATION_1")}
                          </QuoteText>
                        </GridRow>
                        <GridRow>
                          {quoteDocumentList?.id && (
                            <Anchor
                              className="quote-listing__document-link"
                              clickAction={() =>
                                downloadFileFromUrl(
                                  quoteDocumentList.downloadLink,
                                  quoteDocumentList.fileName
                                )
                              }
                              id={`document-tooltip-id${quoteDocumentList.id}`}
                            >
                              <Image
                                src={downloadIcon}
                                alt="downloadIcon"
                                className="quote-listing__quote-action-icon"
                                styles={{ width: "20px" }}
                              />
                              {quoteDocumentList.fileName}
                            </Anchor>
                          )}
                          {!quoteDocumentList && (
                            <Anchor clickAction={generateQuotePdf}>
                              <Image
                                src={downloadIcon}
                                alt="downloadIcon"
                                className="quote-listing__quote-action-icon"
                                styles={{ width: "20px" }}
                              />
                              {quoteId + " - " + t("QUOTE_FILE_PATTERN")}
                            </Anchor>
                          )}
                        </GridRow>
                        <GridRow>
                          <QuoteText>
                            {t("QUOTE_SEND__TO_CLIENT_INFORMATION_2")}
                          </QuoteText>
                        </GridRow>
                      </>
                    )}
                    {!formData.sendToClient.value && (
                      <>
                        <GridRow column="1fr">
                          <LabelText>{t("QUOTE_EMAIL_RECIPIENTS")}</LabelText>
                        </GridRow>
                        <GridRow column="1fr">
                          <ContactContainer>
                            {formData?.emailRecipients?.value.length > 0 &&
                              formData?.emailRecipients?.value.map(
                                (recipient) => (
                                  <ContactButton
                                    key={recipient.relatedContactId}
                                  >
                                    {recipient.name}
                                  </ContactButton>
                                )
                              )}
                          </ContactContainer>
                        </GridRow>
                        <GridRow column="1fr">
                          <TextInput
                            type="text"
                            label={t("QUOTE_EMAIL_SUBJECT")}
                            onChange={onEmailSubjectChange}
                            name="quote-email-subject"
                            id="quote-email-subject"
                            value={String(formData.emailSubject?.value) || ""}
                            isFloat
                            required
                            errorStyles={{ "font-style": "italic" }}
                            labelStyles={
                              formData.emailSubject.error !== ""
                                ? labelStylesError
                                : labelStyles
                            }
                            inputStyles={
                              formData.emailSubject.error !== ""
                                ? inputStylesError
                                : inputStyles
                            }
                            error={formData.emailSubject.error}
                            containerStyles={{ marginTop: "21px" }}
                            placeholder={t("QUOTE_EMAIL_SUBJECT")}
                          />
                        </GridRow>
                        <GridRow column="1fr">
                          <div>
                            <LabelText>{t("QUOTE_EMAIL_BODY")}</LabelText>
                            <CKEditorText
                              descriptionData={convertEditorJSToHTML(
                                adminData?.body
                              )}
                              setDescriptionData={setDescriptionData}
                            />
                            {formData.emailBody.error && (
                              <RequiredMessage>
                                {formData.emailBody.error}
                              </RequiredMessage>
                            )}
                          </div>
                        </GridRow>
                        <DocumentSelectWithType
                          documents={documentList}
                          setFormData={setFormData}
                          formData={formData}
                          selectedDocuments={
                            formData.selectedDocuments.value !== ""
                              ? formData.selectedDocuments.value.split(",")
                              : []
                          }
                        />
                      </>
                    )}
                  </div>
                )}
              </SectionContainer>
            </FlexRow>
          </OptionsWrapper>
        </FormBody>

        <ButtonWrapper>
          {createQuoteActionAPIError && <div>{createQuoteActionAPIError}</div>}
          <Button
            styles={{
              color: "#333",
              background: "#fff",
              border: "1px solid #ccc",
              marginRight: "0.32rem",
              "&:hover": {
                backgroundColor: "#ccc",
              },
            }}
            onClick={onClose}
          >
            <>{t("CLOSE")}</>
          </Button>

          <Button
            styles={{
              color: "white",
              background: "#1BACE4",
              border: "1px solid #1BACE4",
              marginRight: "0.32rem",
              "&:hover": {
                backgroundColor: "#1589b6",
              },
            }}
            onClick={onSubmit}
          >
            <>
              {isQuoteAction && <ClipLoader size={15} color="#fff" />}
              {!isQuoteAction && t("SUBMIT")}
            </>
          </Button>
        </ButtonWrapper>
      </div>
    </Dialog>
  );
};

QuoteActionPopUp.propTypes = {
  t: PropTypes.func.isRequired,
  statusId: PropTypes.string,
  pageType: PropTypes.string,
};

QuoteActionPopUp.defaultProps = {
  statusId: null,
  pageType: "list",
};
export default withTranslation()(QuoteActionPopUp);
